export default __webpack_public_path__ + "static/media/1333.d23d45b9.png";